import { AuthorWithAiApiError } from '../../api/authorWithAiApi';

/** 422 selection rejections keyed by library id, for the picker row the server named. */
export function rowErrorsFrom(error: unknown): Record<string, string> {
  if (!(error instanceof AuthorWithAiApiError) || error.status !== 422) return {};
  return Object.fromEntries(error.fields.map((field) => [field.path.replace(/^Q-?/i, ''), field.message]));
}

/**
 * A refused pick keyed by the picked library ids, so the picker shows it on
 * the row: the server's per-row messages for a 422, otherwise `message` on
 * every picked row. A refusal that names no row (a 400 such as the lesson's
 * anchor picked again as an additional question) would otherwise land in the
 * page's banner, behind the open picker.
 */
export function rowErrorsForPick(error: unknown, libraryIds: readonly string[], message: string): Record<string, string> {
  const rows = rowErrorsFrom(error);
  if (Object.keys(rows).length > 0) return rows;
  return Object.fromEntries(libraryIds.map((id) => [id, message]));
}
